// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-141fd499]{padding-left:10px}button[data-v-141fd499]{background:rgba(0,0,0,0);border:none;outline:none}button.dismiss-all span[data-v-141fd499]{margin-left:5px}button.notallowed[data-v-141fd499]{color:grey;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
